module.exports = __webpack_public_path__ + "img/shield-fill-check.2a06a973.svg";